import { PasswordChanger } from "./../../factories/password-changer/password-changer";
import { TenantSwitcher } from "./../../factories/tenant-switcher/tenant-switcher";

import * as ko from "knockout";
import Scrollbar from "perfect-scrollbar";
import baoMenu from "../../services/bao-menu";
import baoRouter from "../../services/bao-router";
import Bao from "../../services/bao-service";
import { Loading } from "./../../components/loading/loading";
import TabController from "./../../factories/tab-controller";
// import jsonDemo from "./bao-app2-demo.json";
import template from "./bao-app2.html";

export class BaoApp2 {

	public HeaderContainer = ko.observable<HTMLElement>();
	public NavigationOpen = ko.observable<boolean>(false);
	public Groups = ko.observableArray<BaoNavItem>();
	public TabController: TabController;
	public SwitcherEnabled = ko.observable(false);
	public LogoEnabled = ko.observable(false);
	public BellEnabled = ko.observable(false);
	public SearchEnabled = ko.observable(true);
	public SettingsEnabled = ko.observable(true);
	public SearchText = ko.observable("");
	public AppName1 = ko.observable("Checkware");
	public AppName2 = ko.observable("");
	public PopUpOpen = ko.observable(false);
	public LoggedIn = ko.observable(false);
	public Bao = Bao;
	public ContentElement = ko.observable<HTMLElement>();

	public IconsEnabled = ko.observable(false);
	public Open = true;
	public Counter = 0;
	public Updating = ko.observable(false);
	public GroupsFiltered = ko.pureComputed(() => {
		this.Updating(true);
		const result = [];
		ko.utils.arrayForEach(this.Groups(), (i) => {
			i.CloseAllInNavigation();
			if (this.SearchText() == "" || i.FindText(this.SearchText())) {
				result.push(i);
			}
		});
		return result;
	}).extend({
		rateLimit: { method: "notifyWhenChangesStop", timeout: 500 }
	});

	public NavigationIcon = ko.pureComputed(() => {
		if (this.NavigationOpen()) {
			return "fa-times";
		}
		return "fa-bars";
	});

	public IsLoading = ko.observable(true);
	public Initialized = ko.observable(false);
	public SidebarElement = ko.observable<HTMLElement>();
	private _subs: KnockoutSubscription[] = [];

	private sessionCheckIntervall = 60;

	private refSessionCheck = null;

	private ScrollbarContent: Scrollbar;
	private ScrollbarNav: Scrollbar;

	constructor() {
		this._subs.push(this.SidebarElement.subscribe(() => {
			if (this.SidebarElement() != null) {
				this.ScrollbarNav = new Scrollbar(this.SidebarElement());
			}
		}));
		this._subs.push(this.ContentElement.subscribe(() => {
			if (this.ContentElement() != null) {
				// this.ScrollbarContent = Scrollbar.init(this.ContentElement());
			}
		}));
	}

	public RemoveSearchText() {
		this.SearchText("");
	}

	public LoginSuccessfull = () => {
		let initRoute = window.location.hash;
		window.location.hash = "";
		baoRouter.init();
		if (window.__develop == false || window.__develop == null) {
			baoRouter.setHash("checkware/checklistevaluation");
			baoRouter.setHash("search");
		}
		// baoRouter.setHash("dashboardv2");
		if (initRoute == "/" || initRoute == "" || initRoute == "#/") {
			initRoute = "search";
		}
		baoRouter.setHash(initRoute.replace("#/", ""));
		this.IsLoading(true);
		if (window.__offline) {
			this.LoginSuccessfullComplete();
			return $.Deferred().resolve().promise();
		}
		return $.when(Bao.initSession(), baoMenu.initMainMenu()).then(() => {
			this.LoginSuccessfullComplete();
		});
	}

	public ToggleNavigation() {
		this.NavigationOpen(!this.NavigationOpen());
	}

	public TogglePopUp() {
		this.PopUpOpen(!this.PopUpOpen());
	}

	public Logout(forced = false) {
		this.PopUpOpen(false);
		this.IsLoading(true);
		$.when(Bao.post("Login/Logout"), this.TabController.CloseAll(true, true)).then(() => {
			window.location.reload();
		});
	}

	public ChangeTheme() {
		this.PopUpOpen(false);
	}

	public ChangePassword() {
		this.PopUpOpen(false);
		const passwordChanger = new PasswordChanger();
		passwordChanger.Open();
	}

	public ChangeTenant() {
		this.TabController.CloseAll(true).then((closeResult) => {
			if (closeResult) {
				const tenantSwitcher = new TenantSwitcher();
				tenantSwitcher.AutoSelect = false;
				tenantSwitcher.Open().then((result) => {
					this.IsLoading(true);
					window.location.reload();
				});
			}
		});
	}

	public Search() {
		window.location.hash = "search";
	}
	public init() {
		Loading.register(this.IsLoading);
		this.IsLoading(true);
		Bao.initBackend();
		return this.CheckSession().then((result) => {
			this.IsLoading(false);
			if (result) {
				this.LoginSuccessfull();
			} else {
				this.Initialized(true);
			}
		})
			.fail(() => {
				this.IsLoading(false);
			});
		}
	public dispose() {
		this._subs.forEach((s) => {
			s.dispose();
		});
	}

	private LoginSuccessfullComplete() {
		if (baoMenu.contextCollection() != null && baoMenu.contextCollection().length > 0) {
			const container = ko.map.toJS(baoMenu.contextCollection()[0].Container());
			this.convertFromBaoModels(this.Groups, container, null);
		}
		this.LoggedIn(true);
		this.IsLoading(false);
		this.Initialized(true);
		this.SessionChecker();
	}
	private SessionChecker() {
		clearInterval(this.refSessionCheck);
		this.refSessionCheck = setInterval(() => {
			this.CheckSession().then((result) => {
				if (result == false) {
					this.Logout(true);
				}
			});
		}, this.sessionCheckIntervall * 1000);
	}

	private CheckSession(): JQueryPromise<boolean> {
		if (window.__develop) {
			return $.Deferred().resolve(true).promise();
		}
		return Bao.Session.RenewSession();
	}

	private convertFromBaoModels(parentArray: KnockoutObservableArray<BaoNavItem>, container: any[], parent: BaoNavItem) {
		const groups: BaoNavItem[] = [];
		ko.utils.arrayForEach(container, (c: any) => {
			const g = new BaoNavItem(this.SearchText, parent);
			g.Name = c.Caption;
			g.ActionKey = c.ActionKey;
			g.Name = g.Name;
			g.__originalBaoObject = c;

			const items: BaoNavItem[] = [];
			ko.utils.arrayForEach(c.Buttons, (i: any) => {
				const item = new BaoNavItem(this.SearchText, g);
				item.__originalBaoObject = i;
				item.ActionKey = i.ActionKey;
				item.Icon = i.MethodInfo;
				item.Route = i.TargetUrl;
				item.Name = i.Caption != null && i.Caption != "" ? i.Caption : i.ToolTip;
				item.Name = item.Name;
				items.push(item);
			});
			g.Children(items);
			if (c.Container != null && c.Container.length > 0) {
				this.convertFromBaoModels(g.Children, c.Container, g);
			}
			groups.push(g);
		});
		parentArray.push.apply(parentArray, groups);
	}
}

export interface IBaoApp2Params {
	tabController: TabController;
}

export class BaoNavItem {

	public Name: string = "";
	public Route: string = "";
	public ActionKey: string;
	public Icon: string = "";

	public Path = ko.pureComputed(() => {
		if (this.Parent != null && this.Parent.Path() != "") {
			return this.Parent.Path() + " | " + this.Name;
		}
		return this.Name;
	});
	public Children = ko.observableArray<BaoNavItem>([]);
	public ChildrenFiltered = ko.pureComputed(() => {
		const result = [];
		ko.utils.arrayForEach(this.Children(), (i) => {
			if (this.SearchText() == "" || i.FindText(this.SearchText())) {
				result.push(i);
			}
		});
		return result;
	}).extend({
		rateLimit: { method: "notifyWhenChangesStop", timeout: 500 }
	});
	public Open = ko.observable(false);
	public HasChildren = ko.pureComputed(() => {
		return this.ChildrenFiltered().length > 0;
	});
	public __originalBaoObject: any = null;
	public ToggleText = ko.pureComputed(() => {
		return this.Open() ? "-" : "+";
	});

	public constructor(public SearchText: KnockoutObservable<string>, public Parent: BaoNavItem) {

	}

	public ClickHandler() {
		if (this.HasChildren()) {
			this.Open(!this.Open());
		} else if (this.Route != null && this.Route.startsWith("#")) {
			return true;
		} else {
			// TODO - throw event via baoMenu
		}
	}

	public CloseAllInNavigation() {
		this.Open(false);
		ko.utils.arrayForEach(this.Children(), (c) => {
			c.CloseAllInNavigation();
		});
	}

	public FindText(s: string): boolean {
		let childrenFound = false;
		ko.utils.arrayForEach(this.Children(), (c) => {
			if (c.FindText(s)) {
				childrenFound = true;
			}
		});
		if (childrenFound) {
			this.Open(true);
		} else {
			this.Open(false);
		}
		if (s != "" && s != null) {
			const searchWords = s.split(" ");
			let foundAll = false;
			for (const sw of searchWords) {
				if (this.Path().toLowerCase().indexOf(sw.toLowerCase()) > -1) {
					foundAll = true;
				} else {
					foundAll = false;
					break;
				}
			}
			if (foundAll == true) {
				return true;
			}
		}
		return childrenFound;
	}
}

export default {
	viewModel: {
		createViewModel: function (params: IBaoApp2Params, componentInfo) {
			const e: HTMLElement = componentInfo.element;
			let vm: BaoApp2 = null;
			ko.utils.domNodeDisposal.addDisposeCallback(e, () => {
				if (vm != null) {
					vm.dispose();
				}
			});
			vm = new BaoApp2();
			vm.TabController = params.tabController;
			e.classList.remove("cloak");
			vm.init();
			return vm;
		}
	},
	template: template
};
